import SimpleFooter from '../../../../Components/SimpleFooter/Index'
import Collection from './Collection'
import NFTCollected from './NFTCollected'
import NFTCreated from './NFTCreated'
import { BgImage } from './BgImage'
import { OptionRadio } from './OptionRadio'
import { UserInfo } from './UserInfo'
import { returnUserRole } from '../../../../utils/returnUserRole'

export const MobilePage = (props) => {
  const { userData, options } = props
  const userRole = returnUserRole(userData?.role)

  if (!userData)
    return (
      <div className="bg-preto self-center flex">
        <div>Carregando...</div>
      </div>
    )

  return (
    <>
      <section className="flex flex-col items-center justify-center w-full mb-28">
        <BgImage {...props} />

        <UserInfo {...props} />
      </section>
      <OptionRadio {...props} userRole={userRole} />

      {options === 'NFTCollected' && <NFTCollected {...props} />}
      {options === 'NFTCreated' && <NFTCreated {...props} />}
      {options === 'CollectionManagement' && <Collection {...props} />}
      <SimpleFooter />
    </>
  )
}
